import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

const ButtonIcon = ({
  iconName = 'plus',
  iconSize,
  bsClass,
  bsSize = 'small',
  bsStyle = 'primary',
  btnLabel,
  className,
  onClick,
  disabled = false
}) => {
  return (
    <Button
      className={className}
      bsClass={bsClass}
      bsSize={bsSize}
      bsStyle={bsStyle}
      onClick={onClick}
      disabled={disabled}
    >
      <FontAwesomeIcon
        icon={iconName}
        size={iconSize}
      /> {btnLabel}
    </Button>
  );
};

export default ButtonIcon;
